<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-12" v-if="url_panel_show_flag">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-12"
                          body-classes="px-lg-12 py-lg-12"
                          class="border-0">
                        <uploader :options="options" :file-status-text="statusText" class="uploader-example"
                                  ref="uploader" @file-complete="fileComplete" @complete="complete"></uploader>
                        <base-input alternative
                                    type="password"
                                    placeholder="Link Management Password"
                                    addon-left-icon="ni ni-lock-circle-open" v-model="targetpassword">
                        </base-input>

                        <div class="alert alert-warning" role="alert" v-if="button_submit_flag">
                            Retry after uploading.
                        </div>
                        <div class="text-center">
                            <base-button type="primary" class="my-4" @click="submitfunction">Submit
                            </base-button>
                        </div>
                    </card>
                </div>

                <div class="col-lg-5" v-if="!url_panel_show_flag">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0" >
                        <template>
                            <form role="form">
                                <div class="alert alert-success" role="alert">
                                    Your Link (Valid 14 days): <a :href="result_short_url" class="alert-link"
                                                                  v-text="result_short_url" target="view_window"></a>
                                </div>

                                <div id="query">
                                    <h4 type="primary" class="text-primary">QR code:</h4>
                                    <div id="qrcode" ref="qrcode"></div>
                                </div>

                            </form>
                        </template>
                    </card>
                </div>





            </div>
        </div>
    </section>
</template>
<script>
    import QRCode from "qrcodejs2";
    import VueCookies from 'vue-cookies'
    import axios from "axios";


    export default {
        data() {
            return {
                button_submit_flag:false,
                url_panel_show_flag: true,
                targetpassword: "",
                result_short_url: this.GLOBAL.serverSrc,
                options: {
                    target: this.GLOBAL.serverSrc+'/apiv1document/filesuploadservice/', // '//jsonplaceholder.typicode.com/posts/',
                    testChunks: false,
                    // headers:{token:"12321"},//如果加入header需要用这一行
                    query: {token: this.createCode()}//如果在form里增加一项需要添加这个
                },
                attrs: {
                    accept: '*'
                },
                statusText: {
                    success: 'Success',
                    error: 'Error',
                    uploading: 'Uploading',
                    paused: 'Pause',
                    waiting: 'Waiting'
                },
                // token_generated: "123"
            }
        },
        methods: {
            submitfunction(){

                // console.log(this.GLOBAL.serverSrc)
                //正在上传中不允许点submit
                if (window.uploader.isUploading()){
                    this.button_submit_flag=true;
                    return;
                }

              this.url_panel_show_flag=!this.url_panel_show_flag;
                // console.log(this.options.query.token)
                axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                axios
                    .post(this.GLOBAL.serverSrc+'/apiv1document/filesharepostservicecenter/', {
                        token: this.options.query.token,
                        managepassword: this.targetpassword
                    })
                    .then(response => {

                        this.result_short_url = response.data;
                        this.result_short_url = this.GLOBAL.serverSrc+"/" + this.result_short_url;
                        // console.log(response.data.link, this.result_short_url);
                        this.targetpassword = "";

                        console.log(response.data)
                        console.log(this.result_short_url)
                        this.$nextTick(() => {
                            this.qrcode(this.result_short_url)
                        })


                    })
                    .catch(error => console.log(error))
                // .finally(() => this.loading = false)




            },
            complete() {
                console.log('complete', arguments)

            },
            fileComplete() {
                console.log('file complete', arguments)
            },
            qrcode(address) {

                let qrcode = new QRCode('qrcode', {
                    width: 300, // 设置宽度，单位像素
                    height: 300, // 设置高度，单位像素
                    text: address  // 设置二维码内容或跳转地址
                })
            },
            createCode() {//这个函数使用来生成token的，这样一次页面只能有唯一的token，从而保证所有上传都到一个文件夹中
                var code = '';
                //设置长度，这里看需求，我这里设置了4
                var codeLength = 50;
                //设置随机字符
                var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
                //循环codeLength 我设置的4就是循环4次
                for (var i = 0; i < codeLength; i++) {
                    //设置随机数范围,这设置为0 ~ 36
                    var index = Math.floor(Math.random() * 9);
                    //字符串拼接 将每次随机的字符 进行拼接
                    code += random[index];
                }
                //将拼接好的字符串赋值给展示的code
                // this.code = code;
                return code
            },
        },
        mounted() {
            this.$nextTick(() => {
                window.uploader = this.$refs.uploader.uploader
            })
        },
        created() {
            // VueCookies.set('name', 'name', "1h")
        }
    }
</script>
<style>
    .uploader-example {
        /*width: 880px;*/
        /*padding: 15px;*/
        /*margin: 40px auto 0;*/
        /*font-size: 12px;*/
        box-shadow: 0 0 10px rgba(0, 0, 0, .4);
    }

    .uploader-example .uploader-btn {
        margin-right: 4px;
    }

    .uploader-example .uploader-list {
        max-height: 440px;
        overflow: auto;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>
